import ResourceService from './resource.service'

class ContractRouteService extends ResourceService {
  static get resource() {
    return 'contract-route'
  }
}

export default ContractRouteService
